import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Globals } from "../../../../globals";


@Component({
  selector: 'app-entrada-tipo-seleccion',
  templateUrl: './entrada-tipo-seleccion.component.html',
  styleUrls: ['./entrada-tipo-seleccion.component.css']
})
export class EntradaTipoSeleccionComponent implements OnInit {

  @Input() parentForm:FormGroup;
  @Input() nombreControl:string;
  @Input() configCampo;
  @Input() valor;
  valorInput ;

  control = new FormControl("", [Validators.required]);
  lista = [];
  etiqueta;
  nombreCampo;
  constructor(private global:Globals) { }

  ngOnInit() {
    if(this.valor){
      // this.control.setValue(this.valor);
      //////conole.log(this.valor);
    }
    this.parentForm.addControl(this.nombreControl,this.control);
    if(this.global.lenguaje=="es"){
      this.lista =  this.configCampo.DatosSelectEspanol;
      this.etiqueta = this.configCampo.es;
      this.nombreCampo = this.configCampo.es;
    }else{
      this.lista =  this.configCampo.DatosSelectIngles;
      this.etiqueta = this.configCampo.en;
      this.nombreCampo = this.configCampo.en;
    }
  }
}
